import React, { useState } from 'react';
import Sidebar from '../components/Sidebar';
import Topbar from '../components/Topbar';
import CrewLogs from '../components/CrewLogs';
import { NotepadText } from 'lucide-react';

const CrewLogsPage = () => {
  const [layers, setLayers] = useState({
    depth: true,
    temperature: true,
    salinity: false,
  });

  const [vesselData] = useState({
    lat: -23.745,
    lon: -134.120,
    speed: 9.8,
    heading: 212,
  });

  const toggleLayer = (layer) => {
    setLayers(prev => ({
      ...prev,
      [layer]: !prev[layer],
    }));
  };

  return (
    <div 
      className="grid grid-cols-1 lg:grid-cols-[auto_1fr] lg:grid-rows-[56px_1fr] min-h-screen bg-background text-foreground"
      data-testid="crew-logs-page-container"
    >
      <Sidebar layers={layers} toggleLayer={toggleLayer} currentRoute="/logs" />
      <Topbar vesselData={vesselData} />
      <main className="pt-14 lg:pt-0 lg:col-start-2 lg:row-start-2 p-4 md:p-6 relative z-0">
        <div className="mb-6" data-testid="page-header">
          <div className="flex items-center gap-3 mb-2">
            <NotepadText className="h-6 w-6 text-primary" />
            <h1 className="text-2xl font-bold">Crew Logs</h1>
          </div>
          <p className="text-muted-foreground">Mission logs, operational notes, and crew communications</p>
        </div>

        <div className="grid grid-cols-12 gap-4 md:gap-6" data-testid="crew-logs-page-grid">
          <CrewLogs />
        </div>
      </main>
    </div>
  );
};

export default CrewLogsPage;
